import React, { useEffect } from "react";
import marBusiness from "../../assets/mar-business.svg";
import UseRedefinirSenha from "../../hooks/UseRedefinirSenha/UseRedefinirSenha";

const RedefinirSenha = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    const intervalId = setInterval(() => {
      if (document.body.style.overflow !== "hidden") {
        document.body.style.overflow = "hidden";
      }
    }, 100);

    return () => {
      clearInterval(intervalId);
      document.body.style.overflow = "unset";
    };
  }, []);

  const {
    senha,
    setSenha,
    repetir_senha,
    setRepetirSenha,
    validatePassword,
    validateRepeatPassword,
    enviarNovaSenha,
    loading,
    error,
    setError,
    success,
    setSuccess,
  } = UseRedefinirSenha();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !loading) {
        e.preventDefault();
        enviarNovaSenha(senha, repetir_senha);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [senha, repetir_senha, loading, enviarNovaSenha]);

  return (
    <>
      <style>{`
        .ev-page {
          height: calc(100dvh - 80px);
          overflow-y: auto;
          overflow-x: hidden;
          display: block;
          flex-direction: column;
        }

        .ev-container {
          min-height: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 24px 16px;
          max-width: 900px;
          width: 100%;
          margin: 0 auto;
          text-align: center;
          box-sizing: border-box;
          gap: 16px;
        }

        .ev-image {
          max-height: 180px;
          object-fit: contain;
          flex-shrink: 0;
        }

        .ev-title {
          color: #00bcd4;
          font-size: clamp(20px, 2.2vw, 28px);
          font-weight: 700;
          margin-top: -15px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
          line-height: 1.2;
        }

        .ev-subtitle {
          color: #757575;
          font-size: clamp(14px, 1.5vw, 16px);
          line-height: 1.5;
          max-width: 560px;
          margin-top: -25px;
        }

        .ev-alert {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 16px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          width: fit-content;
          margin: -15px auto 15px;
          gap: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }

        .ev-alert-error {
          background-color: #fde8e8;
          color: #c81e1e;
          border: 1px solid #f8b4b4;
        }

        .ev-alert-success {
          background-color: #def7ec;
          color: #03543f;
          border: 1px solid #bcf0da;
        }

        .ev-input {
          width: 100%;
          max-width: 600px;
          height: 59px;
          font-size: 18px;
          border: 1px solid #00bcd4;
          border-radius: 25px;
          padding: 12px 18px;
          outline: none;
          color: #555;
          background: #fff;
          appearance: none;
        }

        .ev-button {
          height: 50px;
          width: 100%;
          max-width: 350px;
          padding: 12px 16px;
          background: linear-gradient(90deg, #1a7fe7, #19c4c9, #0ed079);
          color: #fff;
          border: none;
          border-radius: 25px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          opacity: ${loading ? 0.7 : 1};
        }

        .ev-button:hover {
          background: #0ed079ff  
        }

      `}</style>

      <div className="ev-page">
        <div className="ev-container">
          <img src={marBusiness} alt="Meu Ícone" className="ev-image" />

          <h1 className="ev-title">Redefinir a senha</h1>

          <p className="ev-subtitle">
            As senhas devem conter 8 caracteres, 1 letra maiúscula, 1 minúscula
            e um símbolo “_” “,” “.” “*”
          </p>

          {error && (
            <div className="ev-alert ev-alert-error">
              <svg
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              {error}
            </div>
          )}

          {success && (
            <div className="ev-alert ev-alert-success">
              <svg
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              {success}
            </div>
          )}

          <input
            type="password"
            placeholder="Digite a sua senha..."
            className="ev-input"
            value={senha}
            onChange={(e) => {
              setSenha(e.target.value);
              setSuccess(null);
              setError(null);
            }}
            onBlur={(e) => validatePassword(e.target.value)}
          />

          <input
            type="password"
            placeholder="Confirme a sua senha..."
            className="ev-input"
            value={repetir_senha}
            onChange={(e) => {
              setRepetirSenha(e.target.value);
              setSuccess(null);
              setError(null);
            }}
            onBlur={(e) => validateRepeatPassword(senha, e.target.value)}
          />

          <button
            className="ev-button"
            disabled={loading}
            onClick={() => enviarNovaSenha(senha, repetir_senha)}
          >
            {loading ? "VERIFICANDO..." : "VERIFICAR"}
          </button>
        </div>
      </div>
    </>
  );
};

export default RedefinirSenha;
